import { computed } from 'vue'
import type { Ref } from 'vue'
import type { ChartConfiguration } from '@/stores/type/chartConfiguration.type'
import { useChartConfigurationStore } from '@/stores/chartConfiguration'
import {
  CHART_SORT_ORDER_OPTIONS,
  DEFAULT_SELECTED_PHASES,
  DEFAULT_SORT_ORDER,
  LIFECYCLE_PHASE_GROUP_OPTIONS
} from '@/constants/chartConfiguration'

export const useChartControls = (chartConfiguration: Ref<ChartConfiguration | null>) => {
  const chartConfigurationStore = useChartConfigurationStore()

  const selectedPhases = computed<string[]>(
    () => chartConfiguration.value?.selected_phases ?? DEFAULT_SELECTED_PHASES
  )
  const phaseFilterOptions = LIFECYCLE_PHASE_GROUP_OPTIONS
  const isPhaseActive = (value: string) => selectedPhases.value.includes(value)
  const togglePhase = async (value: string) => {
    const config = chartConfiguration.value
    if (!config) return
    const current = config.selected_phases ?? [...DEFAULT_SELECTED_PHASES]
    const next = current.includes(value)
      ? current.filter((phase) => phase !== value)
      : [...current, value]
    await chartConfigurationStore.updateConfiguration({ ...config, selected_phases: next })
  }

  const sortOrder = computed(() => chartConfiguration.value?.sort_order ?? DEFAULT_SORT_ORDER)
  const sortOrderOptions = CHART_SORT_ORDER_OPTIONS
  const setSortOrder = async (value: string) => {
    const config = chartConfiguration.value
    if (!config || config.sort_order === value) return
    await chartConfigurationStore.updateConfiguration({ ...config, sort_order: value })
  }

  return {
    selectedPhases,
    phaseFilterOptions,
    isPhaseActive,
    togglePhase,
    sortOrder,
    sortOrderOptions,
    setSortOrder
  }
}
